export const SUBJECT_OPTIONS = [
  'Viagens',
  'Passagens Aéreas',
  'Financeiro',
  'Recursos Humanos',
  'Sugestões e Reclamações',
  'Outros',
];

export const CONTACT_TYPES = {
  VIAJANTE: {
    label: 'Viajante',
    value: 'cliente',
  },
  AGENCIA_DE_VIAGENS: {
    label: 'Agência de Viagens',
    value: 'agência',
  },
};

export const SUBJECT_TYPES = {
  VIAGENS: 'Viagens',
  PASSAGENS_AEREAS: 'Passagens Aéreas',
  FINANCEIRO: 'Financeiro',
  RECURSOS_HUMANOS: 'Recursos Humanos',
  SUGESTOES_E_RECLAMACOES: 'Sugestões e Reclamações',
  OUTROS: 'Outros',
};
